import { action } from 'typesafe-actions';
import { uiTypes } from 'shared-components';
import { DocActionTypes } from './types';
import { IDocuments } from '../../../types';

export const addRequiredDocument = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  newDocType: string,
  metadata?: any
) =>
  action(DocActionTypes.ADD_REQUIRED_DOCUMENT, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    newDocType,
    metadata
  });

export const addRequiredDocumentSuccess = (documents: IDocuments) =>
  action(DocActionTypes.ADD_REQUIRED_DOCUMENT_SUCCESS, documents);

export const addRequiredDocumentFailure = (error: string) =>
  action(DocActionTypes.ADD_REQUIRED_DOCUMENT_FAILURE, { error });

export const noBiometrics = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null
) =>
  action(DocActionTypes.NO_BIOMETRICS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey
  });

export const updateATASPending = (docKey: string, isAtasPending: boolean) =>
  action(DocActionTypes.UPDATE_ATAS_PENDING, {
    docKey,
    isAtasPending
  });

export const updateATASSuccess = (docs: IDocuments) => action(DocActionTypes.UPDATE_ATAS_SUCCESS, docs);

export const updateATASFailure = (error: string) => action(DocActionTypes.UPDATE_ATAS_SUCCESS, { error });

export const updateTBTestMetaData = (sponsorType: string, docKey: string, metadata: uiTypes.ITBTestMetaData) =>
  action(DocActionTypes.UPDATE_TB_TEST_META, { sponsorType, docKey, metadata });

export const updateTBSuccess = (docs: IDocuments) => action(DocActionTypes.UPDATE_TB_SUCCESS, docs);

export const updateTBFailure = (error: string) => action(DocActionTypes.UPDATE_TB_SUCCESS, { error });

export const updateVisaRefusalMetaData = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  metadata?: any
) =>
  action(DocActionTypes.UPDATE_VISA_REFUSAL_META_DATA, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    metadata
  });

export const updateVisaRefusalMetaDataSuccess = (docs: IDocuments) =>
  action(DocActionTypes.UPDATE_VISA_REFUSAL_META_DATA_SUCCESS, docs);

export const updateVisaRefusalMetaDataFailure = (error: string) =>
  action(DocActionTypes.UPDATE_VISA_REFUSAL_META_DATA_FAILURE, { error });

export const toggleAcknowledge = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  status: string,
  infoOnlyRequirementsOption = '',
  metadata: any
) =>
  action(DocActionTypes.TOGGLE_ACKNOWLEDGE_DOC, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    status,
    infoOnlyRequirementsOption,
    metadata
  });

export const toggleAcknowledgeSuccess = (docs: IDocuments) =>
  action(DocActionTypes.TOGGLE_ACKNOWLEDGE_DOC_SUCCESS, docs);

export const toggleAcknowledgeFailure = (error: string) =>
  action(DocActionTypes.TOGGLE_ACKNOWLEDGE_DOC_FAILURE, { error });
